/**
 * Bonscan Clarification API
 * OpenAPI contract for Bonscan clarification endpoints consumed by client applications.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TraceActor } from './trace-actor';


export interface Trace { 
    type: Trace.TypeEnum;
    time: string;
    by?: TraceActor | null;
}
export namespace Trace {
    export type TypeEnum = 'OPEN' | 'LOCKED' | 'UNLOCKED' | 'LOCK_TIMEOUT' | 'IN_PROGRESS' | 'UPDATED' | 'DECLINED' | 'RESOLVED';
    export const TypeEnum = {
        Open: 'OPEN' as TypeEnum,
        Locked: 'LOCKED' as TypeEnum,
        Unlocked: 'UNLOCKED' as TypeEnum,
        LockTimeout: 'LOCK_TIMEOUT' as TypeEnum,
        InProgress: 'IN_PROGRESS' as TypeEnum,
        Updated: 'UPDATED' as TypeEnum,
        Declined: 'DECLINED' as TypeEnum,
        Resolved: 'RESOLVED' as TypeEnum
    };
}


